import React, { useEffect, useState } from 'react';
import { Body, FormCadastro, Input, PageHeader, Spin, View, Field, GroupField, SubmitButton, Icon } from '@components';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import App from '@app';
import { getTemplate, reset, putTemplate, postTemplate, getTemplateConectores } from '@ducks/conectoresTemplates';
import styled from 'styled-components';
import { getTemplateGrupo } from '@ducks/conectoresTemplatesGrupos';
import ModalConectoresRelacionados from './ConectoresRelacionados';

const ViewURL = styled(View)`
  flex: 2;
`;

const FieldURL = styled(Field)`
  margin-bottom: 0;
  padding-right: 15px;
`;

const ViewTipURL = styled(View)`
  opacity: 0.6;
  font-size: 12px;
  flex-direction: row;
  align-items: center;
`;

const ViewConectoresRelacionados = styled(View)`
  color: #1890ff !important;
  cursor: pointer;
  margin-right: 15px;
`;

const tipsURL = ['https://teammove.app/api/v1/agrupador', 'https://teammove.app/api/v1/indicador/INDICADOR/v1'];

export default function TemplatesCadastro() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id, idGrupo } = useParams();
  const [form] = FormCadastro.useForm();
  const edicao = id !== '-1';
  const [isModalVisible, setIsModalVisible] = useState(false);

  const template = useSelector(({ conectoresTemplates }) => conectoresTemplates.get('template'));
  const loadingTemplate = useSelector(({ conectoresTemplates }) => conectoresTemplates.get('loadingTemplate'));
  const successTemplate = useSelector(({ conectoresTemplates }) => conectoresTemplates.get('successTemplate'));
  const successPutTemplate = useSelector(({ conectoresTemplates }) => conectoresTemplates.get('successPutTemplate'));
  const successPostTemplate = useSelector(({ conectoresTemplates }) => conectoresTemplates.get('successPostTemplate'));
  const putingTemplate = useSelector(({ conectoresTemplates }) => conectoresTemplates.get('putingTemplate'));
  const postingTemplate = useSelector(({ conectoresTemplates }) => conectoresTemplates.get('postingTemplate'));
  const templateGrupo = useSelector(({ conectoresTemplatesGrupos }) => conectoresTemplatesGrupos.get('templateGrupo'));
  const templateConectores = useSelector(({ conectoresTemplates }) => conectoresTemplates.get('templateConectores'));

  const handleReset = () => dispatch(reset());

  useEffect(() => {
    dispatch(getTemplateConectores(id));
    dispatch(getTemplateGrupo(idGrupo));
  }, []);

  useEffect(() => {
    if (edicao) {
      dispatch(getTemplate(id));
    }
  }, []);

  useEffect(() => {
    if (successPutTemplate || successPostTemplate) {
      handleReset();
      history.goBack();
    }
  }, [successPutTemplate, successPostTemplate]);

  useEffect(() => {
    if (template && edicao) {
      form.setFieldsValue(template);
    }
  }, [successTemplate]);

  function handleSubmit(data) {
    data.idGrupo = idGrupo;
    if (edicao) {
      data.id = id;
      dispatch(putTemplate(data));
    } else {
      dispatch(postTemplate(data));
    }
  }

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCopyToClipboard = (str) => {
    const el = document.createElement('textarea');
    el.value = str;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  };

  return (
    <App>
      <Body>
        <PageHeader title={`Templates${templateGrupo?.ds ? ` - ${templateGrupo.ds}` : ''}`} onBack={() => history.goBack()}>
          <FormCadastro form={form} hideRequiredMark onFinish={handleSubmit}>
            {loadingTemplate ? (
              <Spin />
            ) : (
              <View>
                <GroupField>
                  <Field label='Descrição' name='ds' rules={[{ required: true, message: 'Informe a descrição' }]}>
                    <Input autoFocus />
                  </Field>
                  <ViewURL>
                    <FieldURL label='URL' name='url' rules={[{ required: true, message: 'Informe a URL' }]}>
                      <Input />
                    </FieldURL>
                    <ViewTipURL>
                      Agrupador: {tipsURL[0]} &nbsp; <Icon.CopyOutlined onClick={() => handleCopyToClipboard(tipsURL[0])} />
                    </ViewTipURL>
                    <ViewTipURL>
                      Indicador: {tipsURL[1]} &nbsp; <Icon.CopyOutlined onClick={() => handleCopyToClipboard(tipsURL[1])} />
                    </ViewTipURL>
                  </ViewURL>
                </GroupField>
                <GroupField>
                  <Field label='SQL' name='sql' rules={[{ required: true, message: 'Informe o SQL' }]}>
                    <Input.TextArea rows={15} />
                  </Field>
                </GroupField>

                <View horizontal justifyContent='space-between'>
                  <SubmitButton
                    type='success'
                    htmlType='submit'
                    ghost={putingTemplate || postingTemplate}
                    disabled={putingTemplate || postingTemplate}
                  >
                    {(putingTemplate || postingTemplate) && <Spin />}&nbsp;Salvar
                  </SubmitButton>

                  {templateConectores.length > 0 && (
                    <View>
                      <ViewConectoresRelacionados onClick={showModal}>Conectores Relacionados</ViewConectoresRelacionados>
                      <ModalConectoresRelacionados visible={isModalVisible} data={templateConectores} onOk={handleOk} />
                    </View>
                  )}
                </View>
              </View>
            )}
          </FormCadastro>
        </PageHeader>
      </Body>
    </App>
  );
}
